// extracted by mini-css-extract-plugin
export default {"button":"OpenTemplateEditorButton_button__---Mc"};